import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function OrderConfirmation() {
  const location = useLocation();
  const { orderId, total } = location.state || {};

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <div className="card border-0 shadow-sm text-center" style={{ borderRadius: '2px' }}>
            <div className="card-body p-5">

              {/* Simple checkmark icon, no emojis */}
              <div
                className="mx-auto mb-4 d-flex align-items-center justify-content-center"
                style={{
                  width: '60px',
                  height: '60px',
                  background: '#111',
                  borderRadius: '50%',
                  color: 'white',
                  fontSize: '1.5rem'
                }}
              >
                ✓
              </div>

              <h4
                className="fw-bold text-uppercase mb-2"
                style={{ letterSpacing: '0.08em' }}
              >
                Order Confirmed
              </h4>
              <p className="text-muted mb-4">
                Thanks for shopping with Pork Co. Your order is being processed.
              </p>

              {/* Order ID */}
              {orderId && (
                <div
                  className="p-3 mb-3 text-start"
                  style={{ background: '#f4f4f4', borderRadius: '2px' }}
                >
                  <p className="small text-muted mb-1">Order ID</p>
                  <p
                    className="mb-0 small fw-bold"
                    style={{ wordBreak: 'break-all', fontFamily: 'monospace' }}
                  >
                    {orderId}
                  </p>
                </div>
              )}

              {total && (
                <p className="mb-4">
                  Total charged:{' '}
                  <strong style={{ color: '#c84b11' }}>${total.toFixed(2)}</strong>
                </p>
              )}

              <p className="text-muted small mb-4">
                Your items will ship soon. We'll send a confirmation to your email.
              </p>

              <div className="d-grid gap-2">
                <Link to="/orders" className="btn btn-piggy">
                  View My Orders
                </Link>
                <Link to="/products" className="btn btn-outline-secondary" style={{ borderRadius: '2px' }}>
                  Continue Shopping
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderConfirmation;
